module.exports = __webpack_public_path__ + "img/soundfield_5.3a14284a.jpg";